import BaseProcessor from './BaseProcessor';
import store from '@/store';
import PaymentTypes from '@/models/PaymentTypes';
import { logEvent } from '@/helpers/cieloLogger';

export default class DataOnFileProcessor extends BaseProcessor {
    constructor(multiLanguage) {
        super(multiLanguage);
    }
    /**
     * Processa a transação do Data on File
     */
    async ProcessTransaction() {
        const selectedCard = store.getters['dataOnFile/getSelectedCard'];
        store.dispatch('billingAddress/setFromDof', selectedCard.billingAddress, { root: true });
        const cardPaymentModel = store.getters['cardPayment/getSubmitModel'];

        super.BuildContract({
            ...cardPaymentModel,
            Card: { 
                ...cardPaymentModel.Card,
                Number: selectedCard.maskedNumber,
                tokenId: selectedCard.tokenId,
            },
            PaymentType: PaymentTypes.CREDIT_CARD,
        });

        let response = await super.SendTransactionRequest();
        
        if (super.ResponseIsSuccess(response) == false) return;
        
        store.dispatch('preorder/setTransactionAsFinalized');

        // logEvent({
        //     category: 'data_on_file',
        //     action: 'concluir_compra_dof',
        //     label: '',
        // });

        // Redireciona para a url do merchant caso solicitado
        if (response.Data.Redirect && response.Data.Url)
            return window.location.href = response.Data.Url;

        
        store.dispatch('pipelineV2/pushToOrderStatus', response.Data.OrderId);
    }
}